module.exports = __webpack_public_path__ + "static/media/MrKongs.6c1e8ed8.jpg";